import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';
import Tools from './components/tools';

const vueSignature = require('vue-signature');
Vue.use(vueSignature.default);

import BetterCorpHomeContactUs from './views/_GlobalContactUs/HomeContactUs';
Vue.component('BetterCorpHomeContactUs', BetterCorpHomeContactUs);

import Header from './components/Header';
Vue.component('cube-header', Header);

import Parallax1 from './components/Parallax1';
Vue.component('cube-parallax1', Parallax1);

import Parallax2 from './components/Parallax2';
Vue.component('cube-parallax2', Parallax2);

import FullTitle from './components/FullTitle';
Vue.component('cube-fullTitle', FullTitle);

import InfoBlock from './components/InfoBlock';
Vue.component('cube-infoBlock', InfoBlock);

import ReviewsBlock from './components/ReviewsBlock';
Vue.component('cube-reviewsBlock', ReviewsBlock);

import Footer from './components/Footer';
Vue.component('cube-footer', Footer);

import CTASection from './components/CTASection';
Vue.component('cube-cta-section', CTASection);

import ComingSoon from './components/ComingSoon';
Vue.component('cube-coming-soon', ComingSoon);

import ProductList from './components/ProductList';
Vue.component('cube-product-list', ProductList);

import ProductListItem from './components/ProductListItem';
Vue.component('cube-product-list-item', ProductListItem);

import Button from './components/Button';
Vue.component('cube-button', Button);

Vue.config.productionTip = false;

const FirebaseConfig = {
  apiKey: 'AIzaSyDJ61KjAw_Ld9RL0W0CjbrgZOo8gqRSTUQ',
  authDomain: 'betterwebsite-3.firebaseapp.com',
  databaseURL: 'https://betterwebsite-3.firebaseio.com',
  projectId: 'betterwebsite-3',
  storageBucket: 'betterwebsite-3.appspot.com',
  messagingSenderId: '1035655090762',
  appId: '1:1035655090762:web:8c07e91935a8692a',
};
import firebase from 'firebase/app';
import '@firebase/firestore';
import '@firebase/storage';
import '@firebase/auth';
const app = firebase.initializeApp(FirebaseConfig);
Vue.prototype.$firebase = {
  auth: firebase.auth(app),
  storage: firebase.storage(app),
  firestore: firebase.firestore(app),
};

new Vue({
  router,
  data() {
    return {
      comingSoon: false,
    };
  },
  render: (h) => h(App),
  mounted() {
    if (window.location.hostname === 'localhost' && this.comingSoon) {
      this.$data.comingSoon = false;
    }
    new Tools().fullscreen();
    window.addEventListener('resize', new Tools().fullscreen);
  },
  beforeDestroy: () => {
    window.removeEventListener('resize', new Tools().fullscreen);
  },
}).$mount('#app');
